export default {
    pageTitle: "Download Apps",
    pageSubtitle: "Get the latest Android APK for Africa Business, Egatee, and JDE.",
    downloadApk: "Download APK",
    androidOnly: "Android APK only. Open this page in a browser if WeChat blocks the download.",
    wechatTip: "WeChat may block APK downloads. Tap ··· and choose Open in Browser.",
    appMatata: "Africa Business",
    appMatataDesc: "Cross-border opportunity app for China suppliers.",
    appEgatee: "Egatee",
    appEgateeDesc: "B2B wholesale marketplace for African retailers.",
    appJde: "JDE",
    appJdeDesc: "Field sales and visit app for business development."
}
